import dayjs from 'dayjs';

export const formatDate = row => {
    return dayjs(row).format('MMM DD, YYYY');
};
